import { useNavigate, useLocation } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { Home, BookOpen, BookMarked, PlayCircle, ClipboardList, LayoutDashboard } from "lucide-react";

export default function BottomNav() {
  const navigate = useNavigate();
  const location = useLocation();
  const { user } = useAuth();
  const path = location.pathname;

  const isAdmin = user?.role === "admin";

  const navItems = [
    { label: "Home", icon: Home, path: "/", testId: "bottom-nav-home" },
    { label: "My Course", icon: BookOpen, path: "/my-courses", testId: "bottom-nav-courses" },
    { label: "Free Class", icon: PlayCircle, path: "/free-classes", testId: "bottom-nav-free-class" },
    { label: "Mock Test", icon: ClipboardList, path: "/mock-tests", testId: "bottom-nav-mock-test" },
    { label: "Book", icon: BookMarked, path: "/printed-books", testId: "bottom-nav-books" },
  ];

  if (isAdmin) {
    navItems.push({ label: "Admin", icon: LayoutDashboard, path: "/admin", testId: "bottom-nav-admin" });
  }

  return (
    <nav
      data-testid="bottom-navigation"
      className="fixed bottom-0 left-0 right-0 bg-white border-t-2 border-slate-100 z-50 h-16"
    >
      <div className="max-w-lg mx-auto grid h-full items-center" style={{ gridTemplateColumns: `repeat(${navItems.length}, 1fr)` }}>
        {navItems.map((item) => {
          const active = path === item.path || (item.path !== "/" && path.startsWith(item.path));
          const Icon = item.icon;
          return (
            <button
              key={item.path}
              data-testid={item.testId}
              onClick={() => navigate(item.path)}
              className={`flex flex-col items-center justify-center gap-0.5 transition-none ${
                active ? "text-[#0284C7]" : "text-slate-400"
              }`}
            >
              <Icon size={20} strokeWidth={active ? 2.5 : 1.5} />
              <span className="text-[10px] font-medium">{item.label}</span>
            </button>
          );
        })}
      </div>
    </nav>
  );
}
